module.exports = __webpack_public_path__ + "img/ModuleAdministration.073bb51c.png";